export default __webpack_public_path__ + "static/media/download@2x.03ac6dc3.jpg";